<script>
import ListAction from './ListAction.vue';

/**
 * The Unarchiver component.
 */
export default {
  extends: ListAction
};
</script>
